import { Flex, Space } from "antd";
import styles from "./index.module.less";
import HomeLogo from "@/assets/imgs/ice_white.svg?react";
import { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import tiaozhuan from "@/assets/lottie/tiaozhuan.json";
// import ProductSubNavs from "../SubNavs/Procudt";
import Lottie, { useLottie } from "lottie-react";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useStore } from "@/stores";
import useHoverLottie from "@/hooks/useHoverLottie";
import SVGIcon from "@/components/SVGIcon";
import classNames from "classnames";
import menuJson from "@/assets/lottie/menu.json";
import ArrowDownIcon from "@/assets/imgs/arrow_down.svg?react";
import ArrowUpIcon from "@/assets/imgs/arrow_up.svg?react";
import ArrowLineIcon from "@/assets/imgs/arrow_line.svg?react";
import { useThrottleFn } from "ahooks";
import throttle from "@/utils/throttle";
import { getProducts } from "@/constants/product";

const navs = [
  {
    name: "首页",
    id: "product",
    path: "/",
    subNavs: getProducts(),
  },
  {
    id: "solutions",
    name: "行业案例",
    path: "/solutions",
  },
  {
    id: "news",
    name: "企业资讯",
    path: "/news",
  },
  {
    id: "cooperation",
    name: "生态合作",
    path: "/cooperation",
  },
  {
    id: "developer",
    name: "开发者",
    path: "/developer",
  },
  {
    id: "aboutUs",
    name: "关于小冰",
    path: "/aboutUs",
  },
  {
    id: "joinUs",
    name: "人才招聘",
    path: "/joinUs",
  },
  {
    id: "contactUs",
    name: "联系我们",
  },
];
const PopupMenus = ({ menus }: { menus: any[] }) => {
  const navigate = useNavigate();
  const appStore = useStore("app");
  return (
    <>
      <div className={styles.product_menus_title}>产品方案</div>
      <div className={styles.product_menus}>
        {menus.map((subItem: any) => (
          <Flex
            gap={".12rem"}
            align="center"
            key={subItem.id}
            className={styles.product_menu_item}
            onClick={() => {
              navigate(subItem.value);
            }}
          >
            <img src={subItem.icon} />
            {subItem.name}
          </Flex>
        ))}
      </div>
      <div className={styles.product_menus_title}>商业合作与定制服务</div>
      <div className={styles.product_menus_contact_wrapper}>
        <Flex
          className={styles.product_menus_contact}
          gap={".16rem"}
          align="center"
        >
          <div>企业定制服务</div>
          <div>OEM商业合作</div>
          <div>私有化部署</div>
        </Flex>
        <Flex
          align="center"
          gap={".08rem"}
          justify="center"
          onClick={() => {
            appStore.openContactModal();
          }}
        >
          联系我们
          <SVGIcon icon={<ArrowLineIcon />} />
        </Flex>
      </div>
    </>
  );
};
const MobileHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const appStore = useStore("app");
  // 页面初始化的时候，获取滚动条的高度（上次高度）
  const start_height = useRef(0);

  start_height.current =
    document.documentElement.scrollTop || document.body.scrollTop;

  const [openMenu, setOpenMenu] = useState(false);
  const options = {
    animationData: menuJson,
    loop: false,
    autoplay: false,
  };

  const { View, play, setDirection } = useLottie(options, {
    width: ".2rem",
    height: ".2rem",
  });
  const [openSubMenu, setOpenSubMenu] = useState("");

  useEffect(() => {
    if (openMenu) {
      setDirection(1);
      play();
      document.body.style.overflow = "hidden";
    } else {
      setDirection(-1);
      play();
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [openMenu]);
  useEffect(() => {
    setOpenSubMenu("");
    setOpenMenu(false);
  }, [location.pathname]);
  useEffect(() => {
    const NAVBAR_HIDE_SCROLL_DELTA = 40; // Scroll delta to hide navbar
    const NAVBAR_SHOW_SCROLL_DELTA = -20; // Scroll delta to show navbar
    const VARIANT_CHANGE_SCROLL_THRESHOLD = 80; // Scroll threshold for changing the navbar variant

    const navbar: any = document.getElementById("nav"); // Select navbar
    const originalVariant = navbar.getAttribute("variant"); // Store the original value
    let lastScrollPosition = 0; // Track of the last scroll position
    let cumulativeScrollDelta = 0; // Track cumulative scroll distance

    // Function to update sticky sections based on navbar visibility
    function updateStickySections(hidden: boolean) {
      const stickySections = document.querySelectorAll("[data-sticky-section]"); // Select sticky sections
      stickySections.forEach((section) => {
        if (hidden) {
          section.classList.add("navbar-hidden-sticky");
        } else {
          section.classList.remove("navbar-hidden-sticky");
        }
      });
    }

    // Function to handle scroll events
    function handleScroll() {
      let currentScrollPosition =
        window.scrollY || document.documentElement.scrollTop;
      let scrollDelta = currentScrollPosition - lastScrollPosition;

      if (
        (cumulativeScrollDelta > 0 && scrollDelta < 0) ||
        (cumulativeScrollDelta < 0 && scrollDelta > 0)
      ) {
        cumulativeScrollDelta = scrollDelta;
      } else {
        cumulativeScrollDelta += scrollDelta;
      }

      applyNavbarStyleChanges();

      // Update the last scroll position
      lastScrollPosition = currentScrollPosition;

      // Check scroll position for variant attribute change
      if (currentScrollPosition > VARIANT_CHANGE_SCROLL_THRESHOLD) {
        navbar.setAttribute("variant", "null");
        navbar.setAttribute("scrolled", "true"); // Set 'scrolled' to true when navbar variant changes to null
      } else {
        navbar.setAttribute("variant", originalVariant);
        navbar.setAttribute("scrolled", "false"); // Set 'scrolled' to false when variant is reset
      }
    }

    // Function to apply style changes to the navbar
    function applyNavbarStyleChanges() {
      if (
        cumulativeScrollDelta > NAVBAR_HIDE_SCROLL_DELTA &&
        window.scrollY > 50
      ) {
        navbar.classList.add("navbar-hidden"); // Update navbar position
        updateStickySections(true); // Update sticky position
        cumulativeScrollDelta = 0; // Reset cumulative scroll
      } else if (cumulativeScrollDelta < NAVBAR_SHOW_SCROLL_DELTA) {
        navbar.classList.remove("navbar-hidden"); // Update navbar position
        updateStickySections(false); // Update sticky position
        cumulativeScrollDelta = 0; // Reset cumulative scroll
      }
    }

    const throttledHandleScroll = throttle(handleScroll, 100);
    // Add scroll event listener with throttled handler
    window.addEventListener("scroll", throttledHandleScroll);
    return () => window.removeEventListener("scroll", throttledHandleScroll);
  }, []);
  return (
    <div
      className={classNames(styles.header, {
        [styles.header_opened]: openMenu,
      })}
      id="nav"
    >
      <div className={styles.header_wrapper}>
        <Flex justify="space-between" align="center" style={{ height: "100%" }}>
          <Flex
            align="center"
            className={styles.logo}
            onClick={() => {
              navigate("/");
            }}
            gap={'.08rem'}
          >
            <HomeLogo
              style={{
                width: ".16rem",
              }}
            />
            {/* <SVGIcon icon={<HomeLogo />} width={16} /> */}
            <div className={styles.logo_text}>小冰科技</div>
          </Flex>
          <div
            className={classNames(styles.nav_icon, {
              [styles.nav_icon_open]: openMenu,
            })}
            onClick={() => {
              setOpenMenu(!openMenu);
            }}
          >
            {View}
          </div>
          {/* <div className={styles.navs}>
            <Flex>
              {navs.map((item) => (
                <div
                  key={item.name}
                  id={item.id}
                  className={styles.nav_item}
                  onMouseEnter={() => {
                    setSubNavs(item.subNavs?.component || null);
                  }}
                  onClick={() => {
                    if (item.path) {
                      navigate(item.path);
                    } else if (item.id === "contactUs") {
                      appStore.openContactModal();
                    }
                  }}
                >
                  {item.name}
                </div>
              ))}
            </Flex>
          </div> */}
        </Flex>
      </div>
      <div
        className={classnames(styles.popup_navs, {
          [styles.popup_navs_open]: openMenu,
        })}
      >
        {navs.map((item: any) => (
          <div key={item.id}>
            <Flex
              align="center"
              justify="space-between"
              key={item.id}
              className={styles.popup_nav_item}
              onClick={() => {
                if (item.subNavs) {
                  setOpenSubMenu(openSubMenu === item.id ? "" : item.id);
                } else {
                  if (item.path) {
                    navigate(item.path);
                    setOpenMenu(false);
                    setOpenSubMenu("");
                  } else if (item.id === "contactUs") {
                    appStore.openContactModal();
                    setOpenMenu(false);
                    setOpenSubMenu("");
                  }
                }
              }}
            >
              {item.name}
              {item.subNavs ? (
                <SVGIcon
                  icon={
                    openSubMenu === item.id ? (
                      <ArrowUpIcon />
                    ) : (
                      <ArrowDownIcon />
                    )
                  }
                />
              ) : null}
            </Flex>
            <div
              className={classNames(styles.popup_sub_navs, {
                [styles.popup_sub_navs_open]: openSubMenu === item.id,
              })}
            >
              {item.subNavs && openSubMenu === item.id && (
                <PopupMenus menus={item.subNavs} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default observer(MobileHeader);
